module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "fmh",
    attrs: {
      "id": "ack"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/contents#c_Ack"
    }
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("ACKNOWLEDGEMENTS")])])]), _vm._v(" "), _c('p', {
    staticClass: "co"
  }, [_vm._v("Linda Wall, Malcolm Edwards, Robert Kirby, Jane Sturrock, Nicola Crossley, Ian Preece, Dee Hembury-Eaton, Lynnette Lawrence, Vanessa McMinn, Wendy Dio, Joel McIver, Harry Paterson, Joe Daly, Paul Clark, Glenn Hughes, Neil Murray, Mark Handsley, Hamish Barbour, Steve O’Hagan, Dave Everley, Jim Simpson, Vivian Campbell, Kathy and Kelle Rhoads, Dana Strum, Holly Thompson, and of course all the various members of Black Sabbath that I have had the pleasure – and occasional pain – of knowing over the years.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a27ef4d0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ack.vue
// module id = 66
// module chunks = 0